var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "vehicle-stock-container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("div", { staticClass: "col-md-12" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm.vehicle_stock_info
                        ? _c("h2", [
                            _vm._v(
                              "\n                                Update vehicle stock\n                            "
                            )
                          ])
                        : _c("h2", [
                            _vm._v(
                              "\n                                Create vehicle stock\n                            "
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _vm.vehicleStockData.green_tree_sync_id &&
                    _vm.vehicleStockData.api_id
                      ? [
                          _c("div", { staticClass: "col-md-6 text-right" }, [
                            _vm.$userIsAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    attrs: { target: "_blank" },
                                    on: {
                                      click: function($event) {
                                        return _vm.syncVehicleWithHewia()
                                      }
                                    }
                                  },
                                  [_vm._v("Sync Heiwa Images")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.heiwaSyncLoading
                              ? _c("img", {
                                  staticClass: "loader",
                                  attrs: {
                                    src: "/images/loading.svg",
                                    alt: "Loading...",
                                    width: "16"
                                  }
                                })
                              : _vm._e()
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.onSubmit.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("messages", {
                      attrs: { messages: _vm.messages, scroll: true }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _vm.vehicle_stock_info
                            ? [
                                _vm.vehicleStockData.green_tree_sync_id
                                  ? [
                                      _c("strong", [
                                        _vm._v("Greentree Sync ID:")
                                      ]),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.vehicleStockData
                                              .green_tree_sync_id
                                          ) +
                                          " |\n                                    "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.vehicleStockData.api_id
                                  ? [
                                      _c("strong", [_vm._v("Auc ID:")]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.$laravelRoute(
                                              "vehicle-detail",
                                              _vm.vehicleStockData.api_id
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.vehicleStockData.api_id
                                              ) +
                                              "\n                                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        " |\n                                        "
                                      ),
                                      _c("strong", [_vm._v("Lot #:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.vehicleStockData.lot) +
                                          " |\n                                    "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.vehicleStockData.auction_date
                                  ? [
                                      _c("strong", [_vm._v("Auc Date")]),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.dateToMoment(
                                              _vm.vehicleStockData.auction_date,
                                              "DD/MM/YYYY"
                                            )
                                          ) +
                                          " |\n                                    "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      title:
                                        "This is the date to use in Green Tree import"
                                    }
                                  },
                                  [
                                    _c("strong", [_vm._v("Last updated:")]),
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.dateToMoment(
                                            _vm.vehicleStockData.updated_at,
                                            "DD/MM/YYYY"
                                          )
                                        ) +
                                        " |\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Date added:")]),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.dateToMoment(
                                        _vm.vehicleStockData.created_at,
                                        "DD/MM/YYYY"
                                      )
                                    ) +
                                    " |\n                                    "
                                ),
                                _vm.vehicleStockData.purchased_date
                                  ? [
                                      _c("strong", [
                                        _vm._v("Purchased date: ")
                                      ]),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.dateToMoment(
                                              _vm.vehicleStockData
                                                .purchased_date,
                                              "DD/MM/YYYY"
                                            )
                                          ) +
                                          " |\n                                    "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Status: ")]),
                                _vm._v(" "),
                                _vm.vehicleStockData.status === 1
                                  ? [
                                      _vm._v(
                                        "\n                                        GARAGE\n                                    "
                                      )
                                    ]
                                  : _vm.vehicleStockData.status === 2
                                  ? [
                                      _vm._v(
                                        "\n                                        PURCHASED\n                                    "
                                      )
                                    ]
                                  : _vm.vehicleStockData.status === 3
                                  ? [
                                      _vm._v(
                                        "\n                                        PUBLIC\n                                    "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                        UNSOLD\n                                    "
                                      )
                                    ],
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.vehicleStockData.sold
                                  ? [
                                      _c("strong", [
                                        _vm._v("Heiwa last checked: ")
                                      ]),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.dateToMoment(
                                              _vm.vehicleStockData.sold
                                                .json_checked_at,
                                              "DD/MM/YYYY HH:MM"
                                            )
                                          ) +
                                          " |\n                                        "
                                      ),
                                      _c("strong", [
                                        _vm._v("Heiwa Last updated: ")
                                      ]),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.dateToMoment(
                                              _vm.vehicleStockData.sold
                                                .json_updated_at,
                                              "DD/MM/YYYY HH:MM"
                                            )
                                          ) +
                                          "\n                                    "
                                      )
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-tabs",
                            { staticClass: "info-tabs" },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "Data", active: "" } },
                                [
                                  _c("div", { staticClass: "row mt-3" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12 mb-2" },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.vehicle_details_open = !_vm.vehicle_details_open
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            Vehicle Details\n                                                            "
                                                  ),
                                                  _vm.vehicle_details_open
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-minus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "fa fa-plus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "BCollapse",
                                            {
                                              staticClass: "col-md-12",
                                              model: {
                                                value: _vm.vehicle_details_open,
                                                callback: function($$v) {
                                                  _vm.vehicle_details_open = $$v
                                                },
                                                expression:
                                                  "vehicle_details_open"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "horizontal-group"
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass:
                                                        "stockid-group",
                                                      attrs: {
                                                        label: "Stock id",
                                                        "label-for": _vm.getId(
                                                          "stock_id"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "stock_id"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "stock_id"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "stock_id"
                                                          ),
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "stock_id"
                                                          ),
                                                          placeholder:
                                                            "Enter stock id"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .stock_id,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "stock_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.stock_id"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "note" },
                                                        [
                                                          _vm._v(
                                                            "Alternative ID. Blank to use default.\n                                                                "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "Chassis",
                                                        "label-for": _vm.getId(
                                                          "chassis"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "chassis"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "chassis"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "chassis"
                                                          ),
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "chassis"
                                                          ),
                                                          placeholder:
                                                            "Enter chassis type"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .chassis,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "chassis",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.chassis"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "CO2 Emissions",
                                                        "label-for": _vm.getId(
                                                          "co2_emissions"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "co2_emissions"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "co2_emissions"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "co2_emissions"
                                                          ),
                                                          type: "number",
                                                          state: _vm.fieldState(
                                                            "co2_emissions"
                                                          ),
                                                          placeholder:
                                                            "Enter CO2 emissions"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .co2_emissions,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "co2_emissions",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.co2_emissions"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "Make",
                                                        "label-for": _vm.getId(
                                                          "make"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "make"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "make"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId("make"),
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "make"
                                                          ),
                                                          placeholder:
                                                            "Enter make"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .make,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "make",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.make"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "Model",
                                                        "label-for": _vm.getId(
                                                          "model"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "model"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "model"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "model"
                                                          ),
                                                          type: "text",
                                                          maxlength: "30",
                                                          state: _vm.fieldState(
                                                            "model"
                                                          ),
                                                          placeholder:
                                                            "Enter model"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .model,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "model",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.model"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "Grade",
                                                        "label-for": _vm.getId(
                                                          "grade"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "grade"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "grade"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "grade"
                                                          ),
                                                          type: "text",
                                                          maxlength: "30",
                                                          state: _vm.fieldState(
                                                            "grade"
                                                          ),
                                                          placeholder:
                                                            "Enter grade"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .grade,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "grade",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.grade"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label: "Year",
                                                                "label-for": _vm.getId(
                                                                  "year"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "year"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "year"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "year"
                                                                    ),
                                                                    type:
                                                                      "number",
                                                                    state: _vm.fieldState(
                                                                      "year"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter year"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .year,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "year",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.year"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Mileage",
                                                                "label-for": _vm.getId(
                                                                  "mileage"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "mileage"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "mileage"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "mileage"
                                                                    ),
                                                                    type:
                                                                      "number",
                                                                    state: _vm.fieldState(
                                                                      "mileage"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter mileage"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .mileage,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "mileage",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.mileage"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Engine CC",
                                                                "label-for": _vm.getId(
                                                                  "engine_capacity"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "engine_capacity"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "engine_capacity"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "engine_capacity"
                                                                    ),
                                                                    type:
                                                                      "number",
                                                                    state: _vm.fieldState(
                                                                      "engine_capacity"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter engine capacity"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .engine_capacity,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "engine_capacity",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.engine_capacity"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label: "Trans.",
                                                                "label-for": _vm.getId(
                                                                  "transmission"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "transmission"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "transmission"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-select",
                                                                {
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "transmission"
                                                                    ),
                                                                    options:
                                                                      _vm.transmissionOptions,
                                                                    type:
                                                                      "text",
                                                                    state: _vm.fieldState(
                                                                      "transmission"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter transmission"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .transmission,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "transmission",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.transmission"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Fuel type",
                                                                "label-for": _vm.getId(
                                                                  "fuel_type"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "fuel_type"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "fuel_type"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-select",
                                                                {
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    options:
                                                                      _vm.fuelTypeOptions,
                                                                    id: _vm.getId(
                                                                      "fuel_type"
                                                                    )
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .fuel_type,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "fuel_type",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.fuel_type"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label: "Doors",
                                                                "label-for": _vm.getId(
                                                                  "doors"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "doors"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "doors"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "doors"
                                                                    ),
                                                                    type:
                                                                      "number",
                                                                    state: _vm.fieldState(
                                                                      "doors"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter doors"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .doors,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "doors",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.doors"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label: "Color",
                                                                "label-for": _vm.getId(
                                                                  "color"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "color"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "color"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "color"
                                                                    ),
                                                                    type:
                                                                      "text",
                                                                    state: _vm.fieldState(
                                                                      "color"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter color"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .color,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "color",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.color"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Condition",
                                                                "label-for": _vm.getId(
                                                                  "condition"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "condition"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "condition"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "condition"
                                                                    ),
                                                                    type:
                                                                      "number",
                                                                    step: "0.5",
                                                                    state: _vm.fieldState(
                                                                      "condition"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter condition"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .condition,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "condition",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.condition"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: "Ac",
                                                        "label-for": _vm.getId(
                                                          "ac"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "ac"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "ac"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          id: _vm.getId("ac"),
                                                          options:
                                                            _vm.acOptions,
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "ac"
                                                          ),
                                                          placeholder:
                                                            "Enter ac"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .ac,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "ac",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.ac"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: _vm.getId(
                                                        "equipment"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                                Equipment\n                                                            "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("b-form-input", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    id: _vm.getId("equipment"),
                                                    state: _vm.fieldState(
                                                      "equipment"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .equipment,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "equipment",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.equipment"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      state: _vm.fieldState(
                                                        "equipment"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                                " +
                                                        _vm._s(
                                                          _vm.invalidField(
                                                            "equipment"
                                                          )
                                                        ) +
                                                        "\n                                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "\n                                                                Sales note\n                                                                "
                                                  ),
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                                                                    shown on vehicle list page in large image view\n                                                                "
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("b-form-textarea", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    id: _vm.getId("sales_note"),
                                                    state: _vm.fieldState(
                                                      "sales_note"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .sales_note,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "sales_note",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.sales_note"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      state: _vm.fieldState(
                                                        "sales_note"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                                " +
                                                        _vm._s(
                                                          _vm.invalidField(
                                                            "sales_note"
                                                          )
                                                        ) +
                                                        "\n                                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "\n                                                                Auction note\n                                                                "
                                                  ),
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                                                                    shows on the vehicle detail page\n                                                                "
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("b-form-textarea", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    id: _vm.getId(
                                                      "auction_note"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "auction_note"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .auction_note,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "auction_note",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.auction_note"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      state: _vm.fieldState(
                                                        "auction_note"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                                " +
                                                        _vm._s(
                                                          _vm.invalidField(
                                                            "auction_note"
                                                          )
                                                        ) +
                                                        "\n                                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "horizontal-group" },
                                        [
                                          _c("h3", [_vm._v("Images")]),
                                          _vm._v(" "),
                                          _vm.vehicleStockData.id
                                            ? [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticClass:
                                                              "vehicle-image",
                                                            attrs: {
                                                              label: "Sheet",
                                                              "label-for": _vm.getId(
                                                                "sheet_image"
                                                              ),
                                                              state: _vm.fieldState(
                                                                "sheet_image"
                                                              ),
                                                              "invalid-feedback": _vm.invalidField(
                                                                "sheet_image"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image"
                                                              },
                                                              [
                                                                _vm
                                                                  .vehicleStockData
                                                                  .sheet_image_url
                                                                  ? _c(
                                                                      "el-image",
                                                                      {
                                                                        attrs: {
                                                                          src:
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .sheet_image_url,
                                                                          "preview-src-list": [
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .sheet_image_url
                                                                          ],
                                                                          alt:
                                                                            "Sheet image"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "No image"
                                                                      )
                                                                    ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("b-form-file", {
                                                              ref: "sheet",
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                state: null,
                                                                id: _vm.getId(
                                                                  "sheet_image"
                                                                ),
                                                                placeholder:
                                                                  "Choose a file or drop it here...",
                                                                "drop-placeholder":
                                                                  "Drop file here..."
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.imageUpload(
                                                                    "sheet"
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .sheet_image,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "sheet_image",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.sheet_image"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "same" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "verticle",
                                                            attrs: {
                                                              href: "#!",
                                                              title: "Copy"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.copyImage(
                                                                  "sheet",
                                                                  _vm.soldData
                                                                    .sheetimage
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                    Copy\n                                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "to" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "500px"
                                                            }
                                                          },
                                                          [
                                                            _vm.soldData
                                                              .sheetimage
                                                              ? _c("el-image", {
                                                                  attrs: {
                                                                    src:
                                                                      _vm
                                                                        .soldData
                                                                        .sheetimage,
                                                                    "preview-src-list": [
                                                                      _vm
                                                                        .soldData
                                                                        .sheetimage
                                                                    ],
                                                                    alt:
                                                                      "Sheet image"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticClass:
                                                              "vehicle-image",
                                                            attrs: {
                                                              label: "Front",
                                                              "label-for": _vm.getId(
                                                                "front_image"
                                                              ),
                                                              state: _vm.fieldState(
                                                                "front_image"
                                                              ),
                                                              "invalid-feedback": _vm.invalidField(
                                                                "front_image"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image"
                                                              },
                                                              [
                                                                _vm
                                                                  .vehicleStockData
                                                                  .front_image_url
                                                                  ? _c(
                                                                      "el-image",
                                                                      {
                                                                        attrs: {
                                                                          src:
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .front_image_url,
                                                                          "preview-src-list": [
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .front_image_url
                                                                          ],
                                                                          alt:
                                                                            "Front image"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "No image"
                                                                      )
                                                                    ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("b-form-file", {
                                                              ref: "front",
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                state: null,
                                                                id: _vm.getId(
                                                                  "front_image"
                                                                ),
                                                                placeholder:
                                                                  "Choose a file or drop it here...",
                                                                "drop-placeholder":
                                                                  "Drop file here..."
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.imageUpload(
                                                                    "front"
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .front_image,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "front_image",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.front_image"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "same" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "verticle",
                                                            attrs: {
                                                              href: "#!",
                                                              title: "Copy"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.copyImage(
                                                                  "front",
                                                                  _vm.soldData
                                                                    .frontimage
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                    Copy\n                                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "to" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "500px"
                                                            }
                                                          },
                                                          [
                                                            _vm.soldData
                                                              .frontimage
                                                              ? _c("el-image", {
                                                                  attrs: {
                                                                    src:
                                                                      _vm
                                                                        .soldData
                                                                        .frontimage,
                                                                    "preview-src-list": [
                                                                      _vm
                                                                        .soldData
                                                                        .frontimage
                                                                    ],
                                                                    alt:
                                                                      "Sheet image"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticClass:
                                                              "vehicle-image",
                                                            attrs: {
                                                              label: "Back",
                                                              "label-for": _vm.getId(
                                                                "back_image"
                                                              ),
                                                              state: _vm.fieldState(
                                                                "back_image"
                                                              ),
                                                              "invalid-feedback": _vm.invalidField(
                                                                "back_image"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image"
                                                              },
                                                              [
                                                                _vm
                                                                  .vehicleStockData
                                                                  .back_image_url
                                                                  ? _c(
                                                                      "el-image",
                                                                      {
                                                                        attrs: {
                                                                          src:
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .back_image_url,
                                                                          "preview-src-list": [
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .back_image_url
                                                                          ],
                                                                          alt:
                                                                            "Back image"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "No image"
                                                                      )
                                                                    ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("b-form-file", {
                                                              ref: "back",
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                state: null,
                                                                id: _vm.getId(
                                                                  "back_image"
                                                                ),
                                                                placeholder:
                                                                  "Choose a file or drop it here...",
                                                                "drop-placeholder":
                                                                  "Drop file here..."
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.imageUpload(
                                                                    "back"
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .back_image,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "back_image",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.back_image"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "same" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "verticle",
                                                            attrs: {
                                                              href: "#!",
                                                              title: "Copy"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.copyImage(
                                                                  "back",
                                                                  _vm.soldData
                                                                    .backimage
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                    Copy\n                                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "to" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "500px"
                                                            }
                                                          },
                                                          [
                                                            _vm.soldData
                                                              .backimage
                                                              ? _c("el-image", {
                                                                  attrs: {
                                                                    src:
                                                                      _vm
                                                                        .soldData
                                                                        .backimage,
                                                                    "preview-src-list": [
                                                                      _vm
                                                                        .soldData
                                                                        .backimage
                                                                    ],
                                                                    alt:
                                                                      "Back image"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticClass:
                                                              "vehicle-image",
                                                            attrs: {
                                                              label: "Inside",
                                                              "label-for": _vm.getId(
                                                                "inside_image"
                                                              ),
                                                              state: _vm.fieldState(
                                                                "inside_image"
                                                              ),
                                                              "invalid-feedback": _vm.invalidField(
                                                                "inside_image"
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image"
                                                              },
                                                              [
                                                                _vm
                                                                  .vehicleStockData
                                                                  .inside_image_url
                                                                  ? _c(
                                                                      "el-image",
                                                                      {
                                                                        attrs: {
                                                                          src:
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .inside_image_url,
                                                                          "preview-src-list": [
                                                                            _vm
                                                                              .vehicleStockData
                                                                              .inside_image_url
                                                                          ],
                                                                          alt:
                                                                            "Inside image"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        "No image"
                                                                      )
                                                                    ])
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("b-form-file", {
                                                              ref: "inside",
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                state: null,
                                                                id: _vm.getId(
                                                                  "inside_image"
                                                                ),
                                                                placeholder:
                                                                  "Choose a file or drop it here...",
                                                                "drop-placeholder":
                                                                  "Drop file here..."
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.imageUpload(
                                                                    "inside"
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .inside_image,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "inside_image",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.inside_image"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "same" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "verticle",
                                                            attrs: {
                                                              href: "#!",
                                                              title: "Copy"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.copyImage(
                                                                  "inside",
                                                                  _vm.soldData
                                                                    .insideimage
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                    Copy\n                                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "to" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "500px"
                                                            }
                                                          },
                                                          [
                                                            _vm.soldData
                                                              .insideimage
                                                              ? _c("el-image", {
                                                                  attrs: {
                                                                    src:
                                                                      _vm
                                                                        .soldData
                                                                        .insideimage,
                                                                    "preview-src-list": [
                                                                      _vm
                                                                        .soldData
                                                                        .insideimage
                                                                    ],
                                                                    alt:
                                                                      "Back image"
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                                        You can add images after saving\n                                                    "
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12 mb-2" },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.purchase_admin_open = !_vm.purchase_admin_open
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            Purchase Admin\n                                                            "
                                                  ),
                                                  _vm.purchase_admin_open
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-minus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "fa fa-plus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "BCollapse",
                                            {
                                              staticClass: "col-md-12",
                                              model: {
                                                value: _vm.purchase_admin_open,
                                                callback: function($$v) {
                                                  _vm.purchase_admin_open = $$v
                                                },
                                                expression:
                                                  "purchase_admin_open"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row horizontal-group"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _vm.$userIsSuperAdmin()
                                                        ? _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label: "Status",
                                                                "label-for": _vm.getId(
                                                                  "status"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "status"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "status"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-select",
                                                                {
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    id: _vm.getId(
                                                                      "status"
                                                                    ),
                                                                    options:
                                                                      _vm.statusOptions,
                                                                    state: _vm.fieldState(
                                                                      "status"
                                                                    ),
                                                                    placeholder:
                                                                      "Enter status"
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.onStatusChange
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .status,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "status",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.status"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .status === 4,
                                                              expression:
                                                                "vehicleStockData.status === 4"
                                                            }
                                                          ],
                                                          attrs: {
                                                            label: "Unsold Rep",
                                                            "label-for": _vm.getId(
                                                              "unsold_rep_id"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "unsold_rep_id"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "unsold_rep_id"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("user-selector", {
                                                            attrs: {
                                                              placeholder: "-",
                                                              "allow-empty": true,
                                                              "names-first": true,
                                                              "include-me": false,
                                                              "include-dealers": false,
                                                              "include-admins": true,
                                                              "admins-include-super-admin": true,
                                                              "filter-users-function":
                                                                _vm.filterUnsoldReps
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .unsold_rep_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "unsold_rep_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.unsold_rep_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "horizontal-group"
                                                },
                                                [
                                                  !_vm.vehicle_stock_info
                                                    ? _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Purchased date",
                                                            "label-for": _vm.getId(
                                                              "purchased_date"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "purchased_date"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "purchased_date"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: _vm.getId(
                                                                "purchased_date"
                                                              ),
                                                              type: "date",
                                                              state: _vm.fieldState(
                                                                "purchased_date"
                                                              ),
                                                              placeholder:
                                                                "Enter purchased date"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .purchased_date,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "purchased_date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.purchased_date"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row horizontal-group"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "User",
                                                            "label-for": _vm.getId(
                                                              "user_id"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "user_id"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "user_id"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("user-selector", {
                                                            attrs: {
                                                              placeholder: "-",
                                                              "allow-empty": true,
                                                              "names-first": true
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.onUserChange
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .user_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "user_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.user_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Sold date",
                                                            "label-for": _vm.getId(
                                                              "sold_date"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "sold_date"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "sold_date"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: _vm.getId(
                                                                "sold_date"
                                                              ),
                                                              type: "date",
                                                              state: _vm.fieldState(
                                                                "sold_date"
                                                              ),
                                                              placeholder:
                                                                "Enter sold date"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .sold_date,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "sold_date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.sold_date"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row horizontal-group large-labels"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Currency",
                                                            "label-for": _vm.getId(
                                                              "currency"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "currency"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "currency"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("b-form-select", {
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              id: _vm.getId(
                                                                "currency"
                                                              ),
                                                              options:
                                                                _vm.currencyOptions,
                                                              state: _vm.fieldState(
                                                                "currency"
                                                              ),
                                                              placeholder:
                                                                "Currency"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .currency,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "currency",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.currency"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Final price",
                                                            "label-for": _vm.getId(
                                                              "sold_price"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "sold_price"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "sold_price"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: _vm.getId(
                                                                "sold_price"
                                                              ),
                                                              type: "number",
                                                              disabled: !_vm.canEditSoldPrice(),
                                                              state: _vm.fieldState(
                                                                "sold_price"
                                                              ),
                                                              placeholder:
                                                                "Enter final date"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .vehicleStockData
                                                                  .sold_price,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.vehicleStockData,
                                                                  "sold_price",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "vehicleStockData.sold_price"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row horizontal-group"
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "col-md-6",
                                                      attrs: {
                                                        label: "Ship",
                                                        "label-for": _vm.getId(
                                                          "ship"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "ship"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "ship"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId("ship"),
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "ship"
                                                          ),
                                                          placeholder: "Ship"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .ship,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "ship",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.ship"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "col-md-6",
                                                      attrs: {
                                                        label: "Port",
                                                        "label-for": _vm.getId(
                                                          "port"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "port"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "port"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId("port"),
                                                          type: "text",
                                                          state: _vm.fieldState(
                                                            "port"
                                                          ),
                                                          placeholder: "Port"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .port,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "port",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.port"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row horizontal-group"
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "col-md-6",
                                                      attrs: {
                                                        label: "ETD",
                                                        "label-for": _vm.getId(
                                                          "estimated_departure_date"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "estimated_departure_date"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "estimated_departure_date"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "estimated_departure_date"
                                                          ),
                                                          type: "date",
                                                          state: _vm.fieldState(
                                                            "estimated_departure_date"
                                                          ),
                                                          placeholder:
                                                            "Enter estimated departure date"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .estimated_departure_date,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "estimated_departure_date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.estimated_departure_date"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "col-md-6",
                                                      attrs: {
                                                        label: "ETA",
                                                        "label-for": _vm.getId(
                                                          "estimated_arrival_date"
                                                        ),
                                                        state: _vm.fieldState(
                                                          "estimated_arrival_date"
                                                        ),
                                                        "invalid-feedback": _vm.invalidField(
                                                          "estimated_arrival_date"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "estimated_arrival_date"
                                                          ),
                                                          type: "date",
                                                          state: _vm.fieldState(
                                                            "estimated_arrival_date"
                                                          ),
                                                          placeholder:
                                                            "Enter estimated arrival date"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .estimated_arrival_date,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "estimated_arrival_date",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.estimated_arrival_date"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("Staff note "),
                                                    _c("small", [
                                                      _vm._v(
                                                        "only\n                                                                admins can see this note"
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-form-textarea", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      id: _vm.getId(
                                                        "staff_note"
                                                      ),
                                                      state: _vm.fieldState(
                                                        "staff_note"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .staff_note,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "staff_note",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.staff_note"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-form-invalid-feedback",
                                                    {
                                                      attrs: {
                                                        state: _vm.fieldState(
                                                          "staff_note"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                                " +
                                                          _vm._s(
                                                            _vm.invalidField(
                                                              "staff_note"
                                                            )
                                                          ) +
                                                          "\n                                                            "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.$userIsAdmin()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "form-group"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v("Rep note "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "Doesn't show anywhere except here, this is for the rep to store notes about the vehicle"
                                                          )
                                                        ])
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("b-form-textarea", {
                                                        staticStyle: {
                                                          width: "100%"
                                                        },
                                                        attrs: {
                                                          id: _vm.getId(
                                                            "rep_note"
                                                          ),
                                                          state: _vm.fieldState(
                                                            "rep_note"
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.vehicleStockData
                                                              .rep_note,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.vehicleStockData,
                                                              "rep_note",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "vehicleStockData.rep_note"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-form-invalid-feedback",
                                                        {
                                                          attrs: {
                                                            state: _vm.fieldState(
                                                              "rep_note"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                                " +
                                                              _vm._s(
                                                                _vm.invalidField(
                                                                  "rep_note"
                                                                )
                                                              ) +
                                                              "\n                                                            "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row horizontal-group" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12 mb-2" },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.stock_list_open = !_vm.stock_list_open
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            Stocklist\n                                                            "
                                                  ),
                                                  _vm.stock_list_open
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa fa-minus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "fa fa-plus-square-o ml-1",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "BCollapse",
                                            {
                                              staticClass: "col-md-12",
                                              model: {
                                                value: _vm.stock_list_open,
                                                callback: function($$v) {
                                                  _vm.stock_list_open = $$v
                                                },
                                                expression: "stock_list_open"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Public Date",
                                                    "label-for": _vm.getId(
                                                      "public_date"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "public_date"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "public_date"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: _vm.getId(
                                                        "public_date"
                                                      ),
                                                      type: "date",
                                                      state: _vm.fieldState(
                                                        "public_date"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .public_date,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "public_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.public_date"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.$userIsSuperAdmin()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "checkbox-group"
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Buy Now",
                                                            "label-for": _vm.getId(
                                                              "buy_now"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "buy_now"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "buy_now"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              attrs: {
                                                                id: "buy_now",
                                                                value: "1"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .buy_now,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "buy_now",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.buy_now"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Add to Auto Mailer",
                                                            "label-class":
                                                              "auto-mailer-label",
                                                            "label-for": _vm.getId(
                                                              "add_to_auto_mailer"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "add_to_auto_mailer"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "add_to_auto_mailer"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "add_to_auto_mailer",
                                                                value: "1"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .add_to_auto_mailer,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "add_to_auto_mailer",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.add_to_auto_mailer"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Auto Price Reduction",
                                                            "label-class":
                                                              "auto-reduction-label",
                                                            "label-for": _vm.getId(
                                                              "enable_auto_price_reduction"
                                                            ),
                                                            state: _vm.fieldState(
                                                              "enable_auto_price_reduction"
                                                            ),
                                                            "invalid-feedback": _vm.invalidField(
                                                              "enable_auto_price_reduction"
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "enable_auto_price_reduction",
                                                                value: "1"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .vehicleStockData
                                                                    .enable_auto_price_reduction,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.vehicleStockData,
                                                                    "enable_auto_price_reduction",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "vehicleStockData.enable_auto_price_reduction"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.vehicleStockData
                                                        .enable_auto_price_reduction
                                                        ? _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Price Reduction",
                                                                "label-class":
                                                                  "auto-reduction-label",
                                                                "label-for": _vm.getId(
                                                                  "auto_reduction_price"
                                                                ),
                                                                state: _vm.fieldState(
                                                                  "auto_reduction_price"
                                                                ),
                                                                "invalid-feedback": _vm.invalidField(
                                                                  "auto_reduction_price"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    disabled: !_vm.$userIsSuperAdmin(),
                                                                    type:
                                                                      "number",
                                                                    placeholder:
                                                                      "Default $500"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .vehicleStockData
                                                                        .auto_reduction_price,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.vehicleStockData,
                                                                        "auto_reduction_price",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "vehicleStockData.auto_reduction_price"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.nextReductionDate
                                                        ? _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Next Reduction Date",
                                                                "label-for": _vm.getId(
                                                                  "nextReductionDate"
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "text",
                                                                    disabled: true
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.nextReductionDate,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.nextReductionDate = $$v
                                                                    },
                                                                    expression:
                                                                      "nextReductionDate"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "mt-3" },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        display: "inline-block"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                                Stock Pricing -\n                                                            "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "pricing-link",
                                                      attrs: { href: "#!" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          _vm.show_all_regions = !_vm.show_all_regions
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.show_all_regions
                                                        ? [
                                                            _vm._v(
                                                              "\n                                                                    Hide extra regions\n                                                                "
                                                            )
                                                          ]
                                                        : [
                                                            _vm._v(
                                                              "\n                                                                    Show all regions\n                                                                "
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-table", {
                                                attrs: {
                                                  id: "pricing-table",
                                                  items: _vm.regions_show,
                                                  fields: [
                                                    {
                                                      label: "Stock list",
                                                      key: "enable"
                                                    },
                                                    "name",
                                                    "price",
                                                    "reduction_price",
                                                    "currency"
                                                  ]
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "cell(enable)",
                                                    fn: function(data) {
                                                      return [
                                                        _c("b-form-checkbox", {
                                                          attrs: {
                                                            disabled: !_vm.$userIsSuperAdmin()
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.regionsData[
                                                                data.item.id
                                                              ].is_active,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.regionsData[
                                                                  data.item.id
                                                                ],
                                                                "is_active",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "regionsData[data.item.id].is_active"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "cell(name)",
                                                    fn: function(data) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "b-tooltip",
                                                                rawName:
                                                                  "v-b-tooltip.hover",
                                                                modifiers: {
                                                                  hover: true
                                                                }
                                                              }
                                                            ],
                                                            attrs: {
                                                              title:
                                                                data.item.note
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                data.item.name
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "cell(price)",
                                                    fn: function(data) {
                                                      return [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            disabled: !_vm.$userIsSuperAdmin(),
                                                            type: "text",
                                                            placeholder:
                                                              "Enter price for region"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.regionsData[
                                                                data.item.id
                                                              ].price,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.regionsData[
                                                                  data.item.id
                                                                ],
                                                                "price",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "regionsData[data.item.id].price"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key:
                                                      "cell(reduction_price)",
                                                    fn: function(data) {
                                                      return [
                                                        _c("b-form-input", {
                                                          attrs: {
                                                            disabled: !_vm.$userIsSuperAdmin(),
                                                            type: "text",
                                                            placeholder:
                                                              "Enter reduction price for region"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.regionsData[
                                                                data.item.id
                                                              ].reduction_price,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.regionsData[
                                                                  data.item.id
                                                                ],
                                                                "reduction_price",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "regionsData[data.item.id].reduction_price"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "cell(currency)",
                                                    fn: function(data) {
                                                      return [
                                                        _vm.countries &&
                                                        _vm.countries[
                                                          data.item
                                                            .currency_code
                                                        ]
                                                          ? [
                                                              _vm._v(
                                                                "\n                                                                    " +
                                                                  _vm._s(
                                                                    data.item
                                                                      .currency_code
                                                                  ) +
                                                                  "\n                                                                    (" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .countries[
                                                                      data.item
                                                                        .currency_code
                                                                    ].sign
                                                                  ) +
                                                                  ")\n                                                                "
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mt-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "form-group col-md-6" },
                                      [
                                        _c(
                                          "b-btn",
                                          {
                                            staticClass: "btn",
                                            attrs: { type: "submit" }
                                          },
                                          [_vm._v("Save")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Offers",
                                    disabled: !_vm.vehicle_stock_data
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "container-fluid-wide p-0",
                                      attrs: { id: "offer-edit-tab" }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-3 col-lg-2" },
                                          [
                                            _c("h4", [_vm._v("Offer Email")]),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Email Subject",
                                                  "label-for": _vm.getId(
                                                    "offer_subject"
                                                  ),
                                                  state: _vm.fieldState(
                                                    "offer_subject"
                                                  ),
                                                  "invalid-feedback": _vm.invalidField(
                                                    "offer_subject"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: _vm.getId(
                                                      "offer_subject"
                                                    ),
                                                    type: "text",
                                                    state: _vm.fieldState(
                                                      "offer_subject"
                                                    ),
                                                    placeholder:
                                                      _vm.offer_subject_placeholder
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .offer_subject,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "offer_subject",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.offer_subject"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Offer Price",
                                                  "label-for": _vm.getId(
                                                    "offer_price"
                                                  ),
                                                  state: _vm.fieldState(
                                                    "offer_price"
                                                  ),
                                                  "invalid-feedback": _vm.invalidField(
                                                    "offer_price"
                                                  )
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "link",
                                                      attrs: { href: "#!" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.openCalcOfferPrice.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Calculate")]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: _vm.getId(
                                                      "offer_price"
                                                    ),
                                                    type: "number",
                                                    state: _vm.fieldState(
                                                      "offer_price"
                                                    ),
                                                    placeholder: "Offer price"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .offer_price,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "offer_price",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.offer_price"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Retail Price",
                                                  "label-for": _vm.getId(
                                                    "retail_price"
                                                  ),
                                                  state: _vm.fieldState(
                                                    "retail_price"
                                                  ),
                                                  "invalid-feedback": _vm.invalidField(
                                                    "retail_price"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: _vm.getId(
                                                      "retail_price"
                                                    ),
                                                    type: "number",
                                                    state: _vm.fieldState(
                                                      "retail_price"
                                                    ),
                                                    placeholder: "Retail price"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .retail_price,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "retail_price",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.retail_price"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-form-group",
                                              [
                                                _c("label", [
                                                  _vm._v("Offer note "),
                                                  _c("br"),
                                                  _c("small", [
                                                    _vm._v(
                                                      "Doesn't show anywhere except here, this is in offer email only"
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("b-form-textarea", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    id: _vm.getId("offer_note"),
                                                    state: _vm.fieldState(
                                                      "offer_note"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .offer_note,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "offer_note",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.offer_note"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      state: _vm.fieldState(
                                                        "offer_note"
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm.invalidField(
                                                            "offer_note"
                                                          )
                                                        ) +
                                                        "\n                                                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    staticClass: "btn mb-2",
                                                    attrs: { type: "submit" }
                                                  },
                                                  [_vm._v("Save")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "btn",
                                                    on: {
                                                      click:
                                                        _vm.openSendOfferModal
                                                    }
                                                  },
                                                  [_vm._v("Send Offer")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-9 col-lg-10" },
                                          [
                                            _c("h4", [
                                              _vm._v(
                                                "Click the images you want to include in the offer email"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            !_vm.has_offer_images
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                        There are no images currently selected but all images have\n                                                        been pre-selected to make it easier for you. Please de-select the ones you don't want.\n                                                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "draggable",
                                              {
                                                staticClass:
                                                  "row offer-images mt-4",
                                                on: {
                                                  change:
                                                    _vm.onOfferImagesChange
                                                },
                                                model: {
                                                  value: _vm.offerEmailImages,
                                                  callback: function($$v) {
                                                    _vm.offerEmailImages = $$v
                                                  },
                                                  expression: "offerEmailImages"
                                                }
                                              },
                                              [
                                                _vm._l(
                                                  _vm.offerEmailImages,
                                                  function(image, i) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: _vm.offerImagesClass(
                                                            image
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              attrs: {
                                                                for:
                                                                  "offer-images" +
                                                                  i
                                                              }
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.selectedOfferImages,
                                                                    expression:
                                                                      "selectedOfferImages"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  id:
                                                                    "offer-images" +
                                                                    i,
                                                                  type:
                                                                    "checkbox"
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    image.id,
                                                                  checked: Array.isArray(
                                                                    _vm.selectedOfferImages
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.selectedOfferImages,
                                                                        image.id
                                                                      ) > -1
                                                                    : _vm.selectedOfferImages
                                                                },
                                                                on: {
                                                                  change: [
                                                                    function(
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          _vm.selectedOfferImages,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c = $$el.checked
                                                                          ? true
                                                                          : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            image.id,
                                                                          $$i = _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            (_vm.selectedOfferImages = $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            ))
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            (_vm.selectedOfferImages = $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              ))
                                                                        }
                                                                      } else {
                                                                        _vm.selectedOfferImages = $$c
                                                                      }
                                                                    },
                                                                    _vm.onOfferImagesChange
                                                                  ]
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    image.url,
                                                                  alt:
                                                                    "Extra Image"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Images",
                                    disabled: !_vm.vehicle_stock_data
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row extra-images" },
                                    [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c("h4", [_vm._v("Add new images")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "box" },
                                          [
                                            _c("b-form-file", {
                                              staticClass: "mt-1",
                                              attrs: {
                                                state: null,
                                                placeholder:
                                                  "Choose a file or drop it here...",
                                                "drop-placeholder":
                                                  "Drop file here..."
                                              },
                                              model: {
                                                value: _vm.image,
                                                callback: function($$v) {
                                                  _vm.image = $$v
                                                },
                                                expression: "image"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "mt-3" }, [
                                              _vm._v(
                                                "Selected file: " +
                                                  _vm._s(
                                                    _vm.image
                                                      ? _vm.image.name
                                                      : ""
                                                  ) +
                                                  "\n                                                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.image
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    on: { click: _vm.addImage }
                                                  },
                                                  [_vm._v("Add image")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-9" }, [
                                        _c("h4", [_vm._v("Extra images")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "masonry-layout" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cols" },
                                              _vm._l(
                                                _vm.extraActiveImages,
                                                function(image, i) {
                                                  return _c(
                                                    "div",
                                                    { staticClass: "box" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {},
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "box-header"
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#!",
                                                                    variant:
                                                                      "danger"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.deleteImage(
                                                                        image.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("icon", {
                                                                    attrs: {
                                                                      icon:
                                                                        " fa-trash",
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#!",
                                                                    variant:
                                                                      "info"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.updateImage(
                                                                        image.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  image.active
                                                                    ? _c("i", {
                                                                        staticClass:
                                                                          "fa fa-eye",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true",
                                                                          title:
                                                                            "Make it inactive"
                                                                        }
                                                                      })
                                                                    : _c("i", {
                                                                        staticClass:
                                                                          "fa fa-eye-slash",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true",
                                                                          title:
                                                                            "Make it Active"
                                                                        }
                                                                      })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("el-image", {
                                                            attrs: {
                                                              src: image.url,
                                                              "preview-src-list": [
                                                                image.url
                                                              ]
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("h4", [_vm._v("Inactive Images")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "masonry-layout" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cols" },
                                              _vm._l(
                                                _vm.extraInactiveImages,
                                                function(image, i) {
                                                  return _c(
                                                    "div",
                                                    { staticClass: "box" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {},
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "box-header"
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#!",
                                                                    variant:
                                                                      "danger"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.deleteImage(
                                                                        image.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("icon", {
                                                                    attrs: {
                                                                      icon:
                                                                        " fa-trash",
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    href: "#!",
                                                                    variant:
                                                                      "info"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.updateImage(
                                                                        image.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  image.active
                                                                    ? _c("i", {
                                                                        staticClass:
                                                                          "fa fa-eye",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      })
                                                                    : _c("i", {
                                                                        staticClass:
                                                                          "fa fa-eye-slash",
                                                                        attrs: {
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("el-image", {
                                                            attrs: {
                                                              src: image.url,
                                                              "preview-src-list": [
                                                                image.url
                                                              ]
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.vehicle_stock_info && _vm.$userIsAdmin()
                                ? _c(
                                    "b-tab",
                                    { attrs: { title: "Global List" } },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [_c("h4", [_vm._v("Global List")])]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row horizontal-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Status",
                                                    "label-for": _vm.getId(
                                                      "status"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "status"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "status"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      id: _vm.getId("status"),
                                                      options:
                                                        _vm.globalListStatusOptions,
                                                      state: _vm.fieldState(
                                                        "status"
                                                      ),
                                                      placeholder:
                                                        "Enter status"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_status,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_status",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_status"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "On Behalf User",
                                                    "label-for": _vm.getId(
                                                      "global_list_on_behalf_id"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_on_behalf_id"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "global_list_on_behalf_id"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("user-selector", {
                                                    attrs: {
                                                      placeholder: "-",
                                                      "allow-empty": true,
                                                      "names-first": true,
                                                      "include-me": false,
                                                      "include-dealers": true,
                                                      "include-admins": false,
                                                      "include-reps": false,
                                                      "filter-status": null
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_on_behalf_id,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_on_behalf_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_on_behalf_id"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row horizontal-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Sales Rep",
                                                    "label-for": _vm.getId(
                                                      "global_list_rep_id"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_rep_id"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "global_list_rep_id"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("user-selector", {
                                                    attrs: {
                                                      placeholder: "-",
                                                      "allow-empty": true,
                                                      "names-first": true,
                                                      "include-me": false,
                                                      "include-dealers": false,
                                                      "include-admins": false
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_rep_id,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_rep_id",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_rep_id"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Global Date",
                                                    "label-for": _vm.getId(
                                                      "global_list_date"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_date"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "global_list_date"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: _vm.getId(
                                                        "global_list_date"
                                                      ),
                                                      type: "date",
                                                      state: _vm.fieldState(
                                                        "global_list_date"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_date,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_date"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row horizontal-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Price",
                                                    "label-for": _vm.getId(
                                                      "global_list_display_price"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_display_price"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "global_list_display_price"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: _vm.getId(
                                                        "global_list_display_price"
                                                      ),
                                                      type: "text",
                                                      state: _vm.fieldState(
                                                        "global_list_display_price"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_display_price,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_display_price",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_display_price"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-sm-6 col-md-4"
                                            },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Retail Price",
                                                    "label-for": _vm.getId(
                                                      "global_list_retail"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_retail"
                                                    ),
                                                    "invalid-feedback": _vm.invalidField(
                                                      "global_list_retail"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: _vm.getId(
                                                        "global_list_retail"
                                                      ),
                                                      type: "text",
                                                      state: _vm.fieldState(
                                                        "global_list_retail"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.vehicleStockData
                                                          .global_list_retail,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.vehicleStockData,
                                                          "global_list_retail",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "vehicleStockData.global_list_retail"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-6 col-md-4" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: "Global Note",
                                                  "label-for": _vm.getId(
                                                    "global_list_note"
                                                  ),
                                                  state: _vm.fieldState(
                                                    "global_list_note"
                                                  ),
                                                  "invalid-feedback": _vm.invalidField(
                                                    "global_list_note"
                                                  )
                                                }
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    id: _vm.getId(
                                                      "global_list_note"
                                                    ),
                                                    state: _vm.fieldState(
                                                      "global_list_note"
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vehicleStockData
                                                        .global_list_note,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vehicleStockData,
                                                        "global_list_note",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vehicleStockData.global_list_note"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-row mt-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-group col-md-6"
                                            },
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  staticClass: "btn",
                                                  attrs: { type: "submit" }
                                                },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vehicle_stock_info && _vm.$userIsAdmin()
                                ? _c("b-tab", { attrs: { title: "Logs" } }, [
                                    _c(
                                      "ol",
                                      [
                                        _vm.vehicle_stock_info.logs
                                          ? [
                                              _vm._l(
                                                _vm.vehicle_stock_info.logs,
                                                function(log) {
                                                  return [
                                                    _c(
                                                      "li",
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                                            " +
                                                              _vm._s(
                                                                _vm.dateToMoment(
                                                                  log.created_at,
                                                                  "DD/MM/YYYY HH:MM"
                                                                )
                                                              ) +
                                                              " -\n                                                        " +
                                                              _vm._s(log.log) +
                                                              "\n                                                            "
                                                          ),
                                                          log.data &&
                                                          log.data.changes
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  attrs: {
                                                                    id:
                                                                      "log-" +
                                                                      log.id,
                                                                    href: "#!"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      $event.preventDefault()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                                (view changes)\n                                                            "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]),
                                                        _vm._v(" "),
                                                        log.data &&
                                                        log.data.changes
                                                          ? _c(
                                                              "b-tooltip",
                                                              {
                                                                attrs: {
                                                                  target:
                                                                    "log-" +
                                                                    log.id
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            Data changes:\n                                                            "
                                                                ),
                                                                _vm._l(
                                                                  log.data
                                                                    .changes,
                                                                  function(
                                                                    change,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                index
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              change.from
                                                                            ) +
                                                                            "\n                                                                "
                                                                        ),
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "to"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                                                                " +
                                                                            _vm._s(
                                                                              change.to
                                                                            ) +
                                                                            "\n                                                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                )
                                                              ],
                                                              2
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateToMoment(
                                                _vm.vehicleStockData.created_at,
                                                "DD/MM/YYYY HH:MM"
                                              )
                                            ) +
                                              "\n                                                -\n                                                Record created\n                                            "
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vehicle_stock_info &&
                              _vm.vehicle_stock_info.sold &&
                              _vm.vehicle_stock_info.sold.json &&
                              _vm.vehicle_stock_info.sold.json.inspection &&
                              _vm.$userIsSuperAdmin()
                                ? _c(
                                    "b-tab",
                                    { attrs: { title: "Inspection" } },
                                    [
                                      _c("Inspection", {
                                        attrs: {
                                          vehicle_stock_info:
                                            _vm.vehicle_stock_info,
                                          show_image: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vehicle_stock_info &&
                              _vm.vehicle_stock_info.sold &&
                              _vm.vehicle_stock_info.sold.json &&
                              _vm.vehicle_stock_info.sold.json.unshipped &&
                              _vm.$userIsSuperAdmin()
                                ? _c(
                                    "b-tab",
                                    { attrs: { title: "Inspection" } },
                                    [
                                      _c("NichiboInspection", {
                                        attrs: {
                                          vehicle_stock_info:
                                            _vm.vehicle_stock_info,
                                          show_image: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    title: "Please enter your Yen buy price.",
                    "hide-header-close": true,
                    "no-close-on-backdrop": true,
                    "no-close-on-esc": true
                  },
                  on: { ok: _vm.calculateOfferPrice },
                  model: {
                    value: _vm.calc_offer_yen,
                    callback: function($$v) {
                      _vm.calc_offer_yen = $$v
                    },
                    expression: "calc_offer_yen"
                  }
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Yen Price",
                        "label-for": _vm.getId("yen_buy_price")
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: _vm.getId("yen_buy_price"),
                          type: "number",
                          placeholder: "Yen buy rate"
                        },
                        model: {
                          value: _vm.yen_rate,
                          callback: function($$v) {
                            _vm.yen_rate = $$v
                          },
                          expression: "yen_rate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Over sized fee",
                        "label-for": _vm.getId("over_sized_fee")
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: _vm.getId("over_sized_fee"),
                          type: "number",
                          placeholder: "Over sized fee"
                        },
                        model: {
                          value: _vm.over_sized_fee,
                          callback: function($$v) {
                            _vm.over_sized_fee = $$v
                          },
                          expression: "over_sized_fee"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("vehicle-send-offer-modal", {
        attrs: {
          vehicle: _vm.vehicleStockData,
          vehicle_id: _vm.vehicleStockData.id
        },
        model: {
          value: _vm.sendOfferModalOpen,
          callback: function($$v) {
            _vm.sendOfferModalOpen = $$v
          },
          expression: "sendOfferModalOpen"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d85b915", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d85b915","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/CreatePage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2d85b915","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/CreatePage.vue
// module chunks = 0